import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'indexsort' })
export class IndexsortPipe implements PipeTransform {
  transform(value: any[], property: string): any[] {
    return [...value].sort((a, b) => {
      if (a[property] < b[property]) { return -1; }
      if (a[property] > b[property]) { return 1; }
      return 0;
    });
  }
}
